(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ir-flooring-enquiry"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('.ir-enquiry__colour');
    if (!select) return;
    var area = select.closest('form').querySelector('.ir-enquiry__message');
    if (!area || area.dataset.edited === 'true') return;
    var base = area.dataset.default;
    if (select.value) {
      var product = select.dataset.product;
      area.value = base.replace(product, product + ' in ' + select.value);
    } else {
      area.value = base;
    }
  });
  document.addEventListener('input', function (event) {
    if (event.target.classList && event.target.classList.contains('ir-enquiry__message')) {
      event.target.dataset.edited = 'true';
    }
  });
  } catch(e) { console.error(e); }
})();

})();
